(ns teamoesterreich.admin-mode.administration.help.help-admin
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.webHelpText :as d-webHelpText]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            ))


(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))



(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))

(defn get-it []
  (let [!form-data (r/atom {})
        !opened (r/cursor vstate/app-state [:webHelpText-list :opened])
        !webHelpText-list (r/atom {:loaded false :data {} :opened nil})
        !loaded (r/cursor !webHelpText-list [:loaded])
        !data (r/cursor !webHelpText-list [:data @!opened])
        reload-fn #(reset! !loaded false)]
    (fn []
      (let []
        (when-not @!loaded
          (do
            (d-webHelpText/get-list
              (fn [response]
                (swap! !webHelpText-list assoc :loaded true :data response)))
            [mui/paper
             [:br]
             [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}]
             [mui/typography {} "Lade Daten ... "]
             ]
            ))
        (log/debug "Help text edit" @!data @!loaded @!form-data)
        (when (and @!loaded (not @!data) (a/set-page :help-admin-list)))
        [mui/grid
         {:container  true
          :direction  "row"
          :alignItems "stretch"
          :justify    "flex-start"
          :style      {:textAlign "left" :marginBottom "50px"}
          }
         [mui/grid
          {:item  true
           :xs    12
           :style {:height "50px"}
           }
          [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                           :onClick reload-fn}
           "Hilfetext"]]

         [mui/grid
          {:container false
           :item      true
           :xs        12
           }

          [mui/card
           [mui/card-header
            {:title (str (:webHelpText-title @!data))}]


           [mui/card-content


            [mui/grid
             {:container  true
              :direction  "row"
              :alignItems "stretch"
              :justify    "flex-start"
              :style      {:textAlign "left"}
              }
             [mui/grid
              {:container false :item true
               :xs        8
               :style     {:padding "5px"}
               }
              [mui/text-field {
                               :fullWidth       true
                               :InputLabelProps {:disableAnimation true :shrink true}
                               :disabled        true
                               :defaultValue    (str (:webHelpText-title @!data))
                               :label           "Titel"}]
              ]

             [mui/grid
              {:container false :item true
               :xs        4
               :style     {:padding "5px"}
               }

              [mui/text-field {
                               :fullWidth       true
                               :InputLabelProps {:disableAnimation true :shrink true}
                               :type            "datetime-local"
                               :label           "Letzte Änderung"
                               :disabled        true
                               :defaultValue    (datetime-conv (:webHelpText-date @!data))
                               }]
              ]
             ]

            ]








            [(edit-md-card/get-it (:webHelpText-longContent @!data)
                                  (fn [c] (d-webHelpText/>webBlog-edit (:webHelpText-uuid @!data) {:webHelpText-longContent c} (fn [] (log/debug "Reload after save...") (reload-fn))))
                                  (str backend/BASE_URL "/document")
                                  "Inhalt")]



           [mui/card-actions

            [mui/button {:startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (reset! !opened nil)
                                      (a/set-page :help-admin-list))
                         }
             "Schließen"
             ]
            [mui/form-group
             [mui/form-control-label
              {:style     {:paddingLeft "126px"}
               :label     "Text veröffentlichen"
               :fullWidth true
               :control   (r/as-element
                            [mui/switch
                             {
                              :checked  (or (get @!data :webHelpText-published) false)
                              :onChange (fn [_ v]
                                          ;(println "changed " v)
                                          (d-webHelpText/>webBlog-edit (:webHelpText-uuid @!data) {:webHelpText-published (if v true false)} reload-fn)
                                          )
                              }])}
              ]]

            ]]]

         ]))
    ))


